module.exports = __webpack_public_path__ + "static/img/map.2d39c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/map.png
// module id = dAuO
// module chunks = 51